import inMemoryJwt from "../auth/inMemoryJwt"
import { urlServer } from "../config/GlobalConstant"
import { CREATE_REPRESENTATIVES_LOADING, CREATE_REPRESENTATIVES_SUCCESS } from '../admin/actions/types'
import Swal from "sweetalert2";


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
});

export const createRepresentative = (data) => async dispatch => {

    console.log();
    dispatch({
        type: CREATE_REPRESENTATIVES_LOADING
    })
    await fetch(`${urlServer}representatives/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {

            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: data
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: CREATE_REPRESENTATIVES_SUCCESS,
                    payload: respJson.data
                });
                Toast.fire({
                    icon: 'success',
                    title: 'Registro exitoso'
                })
            }
            else {
                if (respJson.error.code ==='MSJ016') {
                    Toast.fire({
                        icon: 'error',
                        title: respJson.error.msg
                    });
                }

            }
        }).catch(error => {
            console.log()
        })
}
export const getInventoryRepresentativeById = (id) => async dispatch => {
    console.log();
    await fetch(`${urlServer}representativeinventores/get-by-representative`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            representativeId: id,
            limit: 1000,
            skip: 0
        })
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({ type: "SEE_INVENTORY", payload: respJson.data })
        })
}